export const VIEWPORT_TRIANGULATION_FOLLOWER_INTERVAL_MS = 67;

export const createViewportTriangulationFollowerCadence = ({
  dispatch,
  now = () => window.performance?.now?.() || Date.now(),
  setTimer = (callback, delay) => window.setTimeout(callback, delay),
  clearTimer = timer => window.clearTimeout(timer),
  intervalMs = VIEWPORT_TRIANGULATION_FOLLOWER_INTERVAL_MS,
} = {}) => {
  if (typeof dispatch !== 'function') throw new TypeError('dispatch must be a function');
  const interval = Number.isFinite(intervalMs) && intervalMs > 0 ? intervalMs : VIEWPORT_TRIANGULATION_FOLLOWER_INTERVAL_MS;
  let lastDispatchAt = null;
  let latest = null;
  let timer = null;

  const cancelTimer = () => {
    if (timer == null) return;
    clearTimer(timer);
    timer = null;
  };

  const dispatchLatest = () => {
    if (!latest) return false;
    const command = latest;
    latest = null;
    lastDispatchAt = now();
    dispatch(command);
    return true;
  };

  const arm = () => {
    if (timer != null || !latest || lastDispatchAt == null) return;
    const remaining = Math.max(0, interval - (now() - lastDispatchAt));
    timer = setTimer(() => {
      timer = null;
      if (!latest) return;
      const stillRemaining = interval - (now() - lastDispatchAt);
      if (stillRemaining > 0) {
        arm();
        return;
      }
      dispatchLatest();
    }, remaining);
  };

  return {
    submit(command) {
      if (!command) return false;
      latest = command;
      if (lastDispatchAt == null || now() - lastDispatchAt >= interval) {
        cancelTimer();
        return dispatchLatest();
      }
      arm();
      return false;
    },
    flush(command) {
      cancelTimer();
      latest = null;
      if (!command) return false;
      lastDispatchAt = now();
      dispatch(command);
      return true;
    },
    cancel() {
      cancelTimer();
      latest = null;
    },
  };
};
